import { GlobalID } from './global-id';

/* Takes a gid and returns the cache key of the object
 * Specify if the type is an interface subtype using the interfaceType option and the format ['BaseType', 'SubType'].
 * For example: gidToApolloCacheKey(gid, { interfaceType: ['StripeSubscription', 'AccessSubscription'] })
 */
export function gidToApolloCacheKey(gid: string, options: { interfaceType: string[] } = { interfaceType: null }) {
  const parsed = GlobalID.decode(gid, options);
  return parsed.toApolloCacheKey();
}

export function buildGid(model: string, id: number) {
  return new GlobalID({ model, id }).toString();
}
